module.exports = "<div class=\"section\" [class.active]=\"isActive\" [class.invalid]=\"!isValid\" (click)=\"onClick()\">\r\n  <psm-widget-button [type]=\"type\" [showText]=\"false\"></psm-widget-button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/layouts/layouts/section.component.html
// module id = ./src/app/views/presentations/layouts/layouts/section.component.html
// module chunks = main